module.exports = __webpack_public_path__ + "static/img/11.ae394c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11.png
// module id = wByk
// module chunks = 0